import React from 'react';

const FAQ = () => (
  <section id="faq">
    <h2>FAQ</h2>
    <div>
      <h3>What is GrowTube?</h3>
      <p>GrowTube is an app designed to help small YouTubers...</p>
    </div>
    <div>
      <h3>What new features can I expect in future updates?</h3>
      <p>We are continuously working on improving the app...</p>
    </div>
    {/* Add more FAQs here */}
  </section>
);

export default FAQ;
